import { render, staticRenderFns } from "./positionIndicator.vue?vue&type=template&id=b8bb3d2c&scoped=true&lang=pug&"
import script from "./positionIndicator.vue?vue&type=script&lang=js&"
export * from "./positionIndicator.vue?vue&type=script&lang=js&"
import style0 from "./positionIndicator.vue?vue&type=style&index=0&id=b8bb3d2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bb3d2c",
  null
  
)

export default component.exports